<script setup lang="ts">
import Cart from './Cart.vue';

const emits = defineEmits<{
  (e: 'back'): void;
}>();

const { isCheckoutDisabled, goToCheckout } = useCart();

const onBack = (): void => {
  emits('back');
};

const onGoToCheckout = async (): Promise<void> => {
  try {
    await goToCheckout();
  } catch (e) {
    useNotify().error((e as Error).message);
  }
};
</script>

<template>
  <div class="cart-mobile bg-card h-full">
    <UContainer class="
      cart-mobile__header
      fixed
      top-0
      py-2
      grid
      items-center
      bg-header
      z-10
      shadow-lg
      w-full
    ">
      <UButton
        class="text-inherit hover:bg-header rounded-full"
        variant="ghost"
        data-test="header-back"
        aria-label="back"
        @click="onBack()"
      >
        <template #leading>
          <UIcon
            name="ic:round-chevron-left"
            class="text-2xl scale-150 text-inherit"
          />
        </template>
      </UButton>

      <span class="flex items-center justify-center gap-2">
        <UIcon
          name="ic:round-shopping-basket"
          class="text-2xl"
          data-test="header-icon"
        />

        <span
          class="font-semibold text-xl"
          data-test="header-title"
        >
          Your Order
        </span>
      </span>
    </UContainer>

    <div class="cart-mobile__content">
      <Cart data-test="dialog-cart" />
    </div>

    <div class="cart-mobile__footer bg-card">
      <UButton
        block
        class="bg-company-2 font-semibold uppercase text-sm py-4"
        label="Add more items"
        data-test="add-more"
        @click="onBack()"
      />

      <UButton
        block
        class="bg-company-1 font-semibold uppercase text-sm py-4"
        label="Checkout"
        :disabled="isCheckoutDisabled"
        data-test="mobile-checkout"
        @click="onGoToCheckout()"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cart-mobile {

  &__header {
    grid-template-columns: 2.25rem 1fr 2.25rem;
  }

  &__content {
    padding-top: 3.25rem;
    padding-bottom: 8rem;
  }

  &__footer {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.5rem;
    align-items: normal;
  }
}
</style>
